const containSpecialCharOrDigits = (val: string) => {
    const specialChars = /[0-9!-&(-,.-/:-@[-`{-~]/;
    return specialChars.test(val.trim());
};

export default containSpecialCharOrDigits;
